import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("rq_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("rq_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const STATUS_STYLES = {
  received: "bg-[#0B1E3B]/[0.08] text-[#0B1E3B] border-[#0B1E3B]/25",
  awaiting_details: "bg-[#F5A623]/20 text-[#8A5A0B] border-[#F5A623]/50",
  ready: "bg-[#1E9E63]/[0.12] text-[#0F5A32] border-[#1E9E63]/40",
  dispatched: "bg-[#E01A2E]/[0.10] text-[#B01423] border-[#E01A2E]/35",
  closed: "bg-[#5B6B7E]/[0.10] text-[#5B6B7E] border-[#5B6B7E]/30",
};

export const STATUS_LABELS = {
  received: "RECEIVED",
  awaiting_details: "AWAITING DETAILS",
  ready: "READY",
  dispatched: "DISPATCHED",
  closed: "CLOSED",
};

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-ZA", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
